import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { noBillDataModel } from "./noBillDataModel";
import { InvoiceApply } from "@/views/invoice/manage/InvoiceManageTypes";
import { formatLocalDateTime } from "@/utils/utils";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export function NoBillDataTable() {

    const {
        dataSource, pgCfg, loadData,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        applyInvoiceVisible
    } = noBillDataModel();

    const columns: ColumnsType<InvoiceApply> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '账单编码',
            dataIndex: 'billCode',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '申请人',
            dataIndex: 'operator',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '申请时间',
            dataIndex: 'createTime',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (e => formatLocalDateTime(e))
        },
        {
            title: '审核人',
            dataIndex: 'reviewer',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '审核时间',
            dataIndex: 'reviewTime',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (e => formatLocalDateTime(e))
        },
        {
            title: '申请状态',
            dataIndex: 'status',
            align: "center",
            width: 50,
            ellipsis: true,
            render: (v) =>
                v === 0 ? '审核中' :
                    v === 1 ? '审核通过(已调整)' :
                        v === 2 ? '已核销' :
                            v === 3 ? '撤回' :
                                v === 8 ? '审核驳回' :
                                    v === 9 ? '失败' : ''
        }
    ];

    useEffect(() => {
        loadData().then();
    }, [applyInvoiceVisible])

    const onRow = (record: InvoiceApply) => {
        let findIndex = selectedRowKeys.indexOf(record.id);
        let newSelectedRowKeys = [...selectedRowKeys];
        let newSelectedData = selectedData;
        if (findIndex === -1) {
            newSelectedRowKeys.push(record.id);
            newSelectedData.push(record);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            newSelectedData.splice(findIndex, 1);
        }
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedData(newSelectedData);
    };

    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    let newSelectedData = selectedData;
                    if (selected) {
                        for (var i = 0; i < changeRows.length; i++) {
                            let findIndex = selectedRowKeys.indexOf(changeRows[i].id)
                            if (findIndex == -1) {
                                newSelectedData.push(changeRows[i]);
                            }
                        }
                        setSelectedData(newSelectedData);
                        setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                    }
                    else {
                        let spliceArray: number[] = [];
                        for (var i = 0; i < changeRows.length; i++) {
                            let findIndex = selectedRowKeys.indexOf(changeRows[i].id)
                            if (findIndex != -1) {
                                spliceArray.push(i);
                            }
                        }
                        spliceArray = spliceArray.reverse();
                        for (var i = 0; i < spliceArray.length; i++) {
                            newSelectedData.splice(spliceArray[i], 1);
                        }
                        setSelectedData(newSelectedData);

                        setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    }
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

